import { gql } from "lib/apolloClient";

export const plannerElementNodeSetFragment = gql`
  fragment plannerElementNodeSetItem on PlannerElementNodeSet {
    id
    title
    standardSetWrapper {
      gradeScales {
        id
        type
        isArchived
        displayName
      }
    }
  }
`;

export const plannerFragment = {
  plannerElementNodeFragment: gql`
    fragment plannerElementNodeItem on PlannerElementNode {
      id
      uid
      displaySequence
      label
      subText
      code
      type
      subText
      depth
      children
      parent
      subType
      isLeaf
      metadata
      updatedAt
      gradingType
      parentData {
        id
      }
      tags: genericTags {
        id
        label
        icon {
          id
          url
        }
      }
      standardsWrapper {
        standardSet {
          id
          title
        }
        properties {
          isArchived
          isPowerStandard
          isGradedStandard
          grades {
            id
            name
          }
          tags {
            id
            label
          }
        }
      }
      plannerElementNodeWrapper {
        properties {
          isGradedStandard
        }
      }
      dataSetNodeWrapper {
        properties {
          isGraded
          grades {
            id
            name
          }
          subjects {
            id
            name
            isArchived
          }
          subjectGroups {
            id
            name
            constants
          }
          associatedPlannerElementNodes {
            id
            label
            type
            metadata
          }
        }
      }
    }
  `,
  plannerBenchmark: gql`
    fragment plannerBenchmarkItem on PlannerBenchmark {
      id
      uid
      label
      subText
      children
      parent
      benchmarkQuestionCount {
        count
        color
        url
        yearSplit
      }
      levels {
        id
        value
        count
      }
      subject
      levelId
      displaySequence
      depth
      type
      code
      grades {
        id
        name
      }
      isLeaf
      tags {
        id
        label
        icon {
          id
          url
        }
      }
      resolvedSubject {
        id
        isArchived
      }
      parentData {
        id
      }
      gradingType
      standardsWrapper {
        standardSet {
          id
          title
        }
        properties {
          isArchived
          isPowerStandard
          isGradedStandard
          grades {
            id
            name
          }
          tags {
            id
            label
          }
        }
      }
      dataSetNodeWrapper {
        properties {
          isGraded
        }
      }
    }
  `,
};
